import { Link } from "@chakra-ui/react";
import { Link as ReactRouterLink } from "react-router-dom";

export type MaybeLinkProps = {
  to?: string;
  isExternal?: boolean;
  children: React.ReactNode;
};

export const MaybeLink: React.FC<MaybeLinkProps> = ({
  to,
  isExternal,
  children,
}) => {
  if (to) {
    return (
      <Link
        color="primary.500"
        textDecoration="underline"
        as={ReactRouterLink}
        to={to}
        isExternal={isExternal}
      >
        {children}
      </Link>
    );
  }
  return <>{children}</>;
};
